import mutations from '@/store/modules/database/detail/detail.mutations';
import actions from '@/store/modules/database/detail/detail.actions';
import getters from '@/store/modules/database/detail/detail.getters';
import { KeyLabel } from '@/store/mutations-typesCommon';
import database from '@/utils/templates/database.template';

export interface State {
  currentSubType: KeyLabel;
  databaseInstances: KeyLabel[];
  currentDatabaseInstance: any;
  buckets: KeyLabel[];
  currentBucket: KeyLabel;
  clusters: KeyLabel[];
  currentCluster: KeyLabel;
}

export const initialState: State = {
  currentSubType: database.navTabs[0].tabs[0],
  databaseInstances: [],
  currentDatabaseInstance: {},
  buckets:[],
  currentBucket: { key: '', label: '' },
  clusters:[],
  currentCluster: { key: '', label: '' },

};

export default {
  namespaced: true,
  state: initialState,
  mutations: mutations,
  actions: actions,
  getters: getters
};
